// extracted by mini-css-extract-plugin
export default {"link":"ProductDetail_link__j1H-R","theme-grayscale":"ProductDetail_theme-grayscale__htYGF"};